




































































































































































import { defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import GoBackButton from '@/components/GoBackButton.vue';
import feathers from '@/feathers-client';
import moment from 'moment';
import Localities from './Localities.vue';
import { useActions, useState } from '@u3u/vue-hooks';

export default defineComponent({
  props: {
    customerInfo: null,
    viewing: Boolean,
  },
  components: {
    GoBackButton,
    Localities,
  },
  setup(props, { emit }) {
    const { healthInsurances } = useState(['healthInsurances']);
    const { getHealthInsurances } = useActions(['getHealthInsurances']);
    const form = ref();
    const valid = ref(false);
    const loading = ref(false);
    const selectedLocality = ref(0);
    const numberRule = [
      (value: string) => !!value || 'Este campo es obligatorio',
      (value: string) => {
        const pattern = /^[0-9]*$/;
        return pattern.test(value) || 'Solo números';
      },
    ];
    const dniRule = [
      (value: string) => !!value || 'Este campo es obligatorio',
      (value: string) => {
        const pattern = /^[0-9]*$/;
        return pattern.test(value) || 'Solo números';
      },
      (value: string) => value.length <= 8 || 'Máximo 8 caracteres',
    ];

    const emailRule = [
      (value: string) => !!value || 'Este campo es obligatorio',
      (value: string) => {
        const pattern =
          /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
        return pattern.test(value) || 'Formato de correo electrónico inválido';
      },
    ];
    const requiredRule = [(v: string) => !!v || 'Este campo es obligatorio'];

    const emitToParent = () => {
      loading.value = true;
      const formValid = form.value.validate();
      try {
        if (formValid) {
          const formData = {
            ...props.customerInfo,
          };
          emit('submitCustomerForm', formData);
        }
      } catch (error) {
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      await getHealthInsurances(true);
    });

    const onSelectLocalityChanged = (locality: any) => {
      props.customerInfo.locality = locality;
    };
    const onSelectHealthInsuranceChanged = (healthInsurance: any) => {
      props.customerInfo.health_insurance = healthInsurance;
    };

    watch(props, () => {
      if (props.customerInfo.locality) selectedLocality.value = props.customerInfo.locality;
    });

    return {
      requiredRule,
      numberRule,
      dniRule,
      emailRule,
      form,
      valid,
      emitToParent,
      onSelectLocalityChanged,
      onSelectHealthInsuranceChanged,
      loading,
      moment,
      selectedLocality,
      healthInsurances,
    };
  },
});
